module.exports = __webpack_public_path__ + "img/honortop_bg.50c2fd8c.jpg";